/**
 * EnergyScoreCard
 * Enerji skorları (progress bar tarzı)
 */

import React from 'react';

export default function EnergyScoreCard({ scores }) {
  if (!scores || scores.length === 0) return null;
  
  return (
    <div className="oracle-energy-section">
      <h3 className="oracle-energy-title">Enerji Haritası</h3>
      
      <div className="oracle-energy-list">
        {scores.map((score, index) => (
          <div key={index} className="oracle-energy-item">
            <span className="oracle-energy-icon">{score.icon}</span>
            <div className="oracle-energy-bar-container">
              <div className="oracle-energy-label">
                <span>{score.category_tr}</span>
                <span style={{ color: '#a855f7', fontWeight: 600 }}>{score.score}</span>
              </div>
              <div className="oracle-energy-bar">
                <div 
                  className={`oracle-energy-fill ${score.category}`}
                  style={{ width: `${score.score}%` }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
